/*eslint-disable no-undef */
import phina from 'phina.js'

export default ()=>{
/**
 * @class RequestScene
 * @extends phina.form.HttpRequestScene
 */
phina.define("RequestScene",{
  superClass: "phina.form.HttpRequestScene",
  init: function(param){
    param = (param||{}).$safe(RequestScene.defaults);
    this.superInit(param);
    this.successDialog = param.successDialog;

    phina.display.RectangleShape({
      width:1000, height:600,
      fill:'#000', stroke:'transparent'
    }).setPosition(500,300).fromJSON({alpha:0.5})
    .addChildTo(this);
    phina.display.Sprite("img/ui/loading.gif")
    .setPosition(500,300).addChildTo(this);

  },
  after: function(session){
    var self = session.scene;
    var app = self.app;
    app.popScene();
    if(session.response && [200, 201, 0].indexOf(parseInt(session.response.error)) == -1){
      return session.error(session.response);
    }
    app.currentScene.traceChild(function(v){
      v._touchFlags = {};
      v.has('pointend') && v.flare('pointend');
    });
    var nextArguments = {};
    var klass = session.success(session.response, nextArguments);
    var scene = phina.using(klass);
    if(klass){
      if(scene.assets){
        return phina.asset.AssetLoader()
          .load(scene.assets)
          .then(function(){
            if(nextArguments.pushScene){
              var _scene = scene.call(null, nextArguments);
              app.pushScene(_scene);
            }else{
              app.currentScene.exit({nextLabel:klass}.$extend(nextArguments));
            }
          })
      }else{
        return phina.util.Flow.resolve(session)
          .then(function(){
            if(nextArguments.pushScene){
              var _scene = scene.call(null, nextArguments);
              app.pushScene(_scene);
            }else{
              app.currentScene.exit({nextLabel:klass}.$extend(nextArguments));
            }
          })
      }
    }else if(self.successDialog){
      var win = phina.display.RectangleShape({
        width:1000, height:60,
        stroke:'#FFF', fill:'#CCC',
      }).setPosition(500,300)
      .addChildTo(app.currentScene);
      win.tweener
        .clear()
        .wait(1000)
        .fadeOut(500)
        .call(function(){ win.remove(); });
      phina.display.Label({
        width:360, height:60,
        text:"登録しました！", align:'center',
        fontSize:30, fontColor:'#000',
      }).setPosition(0,0).addChildTo(win);
    }
  },
  _static:{
    defaults:{
      width:1000, height:600,
      sccessDialog:false,
      error: function(res){
        // console.log(res);
        this.app.pushScene(
          DefaultErrorScene({
            status:res.error,message:res.msg,
            pid:res.ProcessID,
          }));
      },
    }
  }
});

phina.define('DefaultErrorScene',{
  superClass:'phina.display.DisplayScene',
  init: function(param){
    var self = this;
    param = (param||{}).$safe(DefaultErrorScene.defaults);
    this.superInit(param);

    phina.display.RectangleShape({
      width:1000, height:600,
      fill:'#000', stroke:'transparent'
    }).setPosition(500,300).fromJSON({alpha:0.5})
    .addChildTo(this);

    if(parseInt(param.status)/100 >= 5){
      phina.display.LabelArea({
        width:400, height:200,
        text:'{0}(PID={2})'.format(param.message,param.status,param.pid),
        fontSize:21, fill:'#FFF',
        align:'left',
      }).setPosition(500,300)
      .addChildTo(this)

      phina.display.Sprite('sorry001')
      .setSize(250,225)
      .setPosition(500,400)
      .addChildTo(this)
    }else{
      phina.display.LabelArea({
        width:400, height:200,
        text:'{0}'.format(param.message,param.status,param.pid),
        fontSize:21, fill:'#FFF',
        align:'left',
      }).setPosition(500,300)
      .addChildTo(this)

      NormalButton({
        width:150, height:40,
        text:'OK', fontSize:24,
      }).setPosition(500,500)
      .addChildTo(this)
      .on('click', function(){
        self.app.popScene();
      })
    }
  },
  _static:{
    defaults:{
      width:1000, height:600,
      message:'不明なエラーが発生しました。\n管理者に問い合わせをお願いします。',
    }
  }
})

}
